



















import { defineComponent } from '@vue/composition-api';
import TTAcountIcon from '@tt4b/ttam-assets/src/svgs/creative/tt-account-icon.svg';
const name = 'ttam-identity-tiktok-post-authorize-button';

export default defineComponent({
  name,
  components: {
    TTAcountIcon,
  },
  props: {
    showTips: {
      type: Boolean,
      default: false,
    },
    ifButton: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const onClick = () => {
      emit('add-click');
    };
    return {
      name,
      onClick,
    };
  },
});
